export default {
  maxHeight: '850px',
  maxHeight800px: '800px',
  maxHeight880px: '880px',
  maxHeight960px: '960px',
  maxHeightNumber: 850,
  midHeight: '750px',
};
